const pageNameKey = "search";

export const searchEn = {
  [pageNameKey]: {
    title: "Search Companies and Machines",
    usersTitle: "Search Users",
    technicalUsersApiTitle: "Search Technical Users (API)",
    technicalUsersGatewayTitle: "Search Technical Users (Gateway)",
    filter: "Filter",
    caretDown: "Caret down",
    search: "Search",
    remove: "Remove",
    clear: "Clear search",
    noResults: "No search results found",
  },
};

export const searchPtBr = {
  [pageNameKey]: {
    title: "Pesquisar empresas e máquinas",
    usersTitle: "Buscar usuários",
    technicalUsersApiTitle: "Buscar usuários técnicos (API)",
    technicalUsersGatewayTitle: "Buscar usuários técnicos (Gateway)",
    filter: "Filtrar",
    caretDown: "Seta para baixo",
    search: "Pesquisar",
    remove: "Remover",
    clear: "Limpar pesquisa",
    noResults: "Nenhum resultado encontrado",
  },
};

export const searchDe = {
  [pageNameKey]: {
    title: "Unternehmen und Maschinen suchen",
    usersTitle: "Benutzer suchen",
    technicalUsersApiTitle: "Technische Benutzer (API) suchen",
    technicalUsersGatewayTitle: "Technische Benutzer (Gateway) suchen",
    filter: "Filter",
    caretDown: "Pfeil nach unten",
    search: "Suchen",
    remove: "Entfernen",
    clear: "Suche löschen",
    noResults: "Keine Suchergebnisse gefunden",
  },
};

export const searchZhHans = {
  [pageNameKey]: {
    title: "搜索公司和机器",
    usersTitle: "搜索用户",
    technicalUsersApiTitle: "搜索技术用户（API）",
    technicalUsersGatewayTitle: "搜索技术用户（网关）",
    filter: "过滤",
    caretDown: "向下箭头",
    search: "搜索",
    remove: "移除",
    clear: "清除搜索",
    noResults: "没有找到搜索结果",
  },
};

export const searchIt = {
  [pageNameKey]: {
    title: "Cerca Aziende e Macchine",
    usersTitle: "Cerca Utenti",
    technicalUsersApiTitle: "Cerca Utenti Tecnici (API)",
    technicalUsersGatewayTitle: "Cerca Utenti Tecnici (Gateway)",
    filter: "Filtro",
    caretDown: "Freccia verso il basso",
    search: "Cerca",
    remove: "Rimuovi",
    clear: "Cancella ricerca",
    noResults: "Nessun risultato trovato",
  },
};

export const searchEs = {
  [pageNameKey]: {
    title: "Buscar empresas y máquinas",
    usersTitle: "Buscar usuarios",
    technicalUsersApiTitle: "Buscar usuarios técnicos (API)",
    technicalUsersGatewayTitle: "Buscar usuarios técnicos (Gateway)",
    filter: "Filtrar",
    caretDown: "Flecha hacia abajo",
    search: "Buscar",
    remove: "Eliminar",
    clear: "Borrar búsqueda",
    noResults: "No se encontraron resultados de búsqueda",
  },
};

export const searchNl = {
  [pageNameKey]: {
    caretDown: "Invoegteken omlaag",
    clear: "Zoekopdracht wissen",
    filter: "Filter",
    noResults: "Geen zoekresultaten gevonden",
    remove: "Verwijderen",
    search: "Zoeken",
    technicalUsersApiTitle: "Zoek technische gebruikers (API)",
    technicalUsersGatewayTitle: "Zoek technische gebruikers (Gateway)",
    title: "Bedrijven en machines zoeken",
    usersTitle: "Gebruikers zoeken",
  },
};

export const searchTr = {
  [pageNameKey]: {
    caretDown: "Aşağı imleç",
    clear: "Aramayı temizle",
    filter: "Filtre",
    noResults: "Arama sonucu bulunamadı",
    remove: "Kaldırmak",
    search: "Aramak",
    technicalUsersApiTitle: "Teknik Kullanıcıları Ara (API)",
    technicalUsersGatewayTitle: "Teknik Kullanıcıları Ara (Ağ Geçidi)",
    title: "Şirketleri ve Makineleri Ara",
    usersTitle: "Kullanıcıları Ara",
  },
};
